export enum Type {
  AJAX_POST_INSURANGE_QUOTE         = 'AJAX_POST_INSURANGE_QUOTE',
  AJAX_POST_INSURANGE_QUOTE_SUCCESS = 'AJAX_POST_INSURANGE_QUOTE_SUCCESS',
  AJAX_POST_INSURANGE_QUOTE_FAIL    = 'AJAX_POST_INSURANGE_QUOTE_FAIL',
}
